module.exports = __webpack_public_path__ + "static/media/h4p_top_01.a52d52ba.gif";